import { getTimeWork } from '@helpers/getTimeWork';

export const TimeWorkText = (timeWork): string => {
  return timeWork ? `<div class="balloon__timeWork">${getTimeWork(timeWork)}</div>` : '';
};
